module.exports = __webpack_public_path__ + "img/icon_plus_blue.a6d47787.svg";